import { cosignatureRequestsTyped } from "@/api/(requests)/cosignatureTyped";
import type { CosignMetaBody } from "@/core/types";

export async function getNoteCosignMeta(documentId: string): Promise<CosignMetaBody> {
  return cosignatureRequestsTyped.get_note_cosign_meta({ urlParams: { documentId } });
}
